import * as React from 'react';
import Button from '@mui/material/Button';
import {Box, CircularProgress, FormControlLabel, Grid, Pagination, Stack, Switch, Typography} from '@mui/material';
import {deleteHomeMatchAd, getHomeMatchAds} from '../Api';
import {useNavigate} from 'react-router-dom';
import HomeMatchAdDto from "../models/dtos/HomeMatchAdDto";
import HomeMatchAdsCard from "../components/HomeMatchAdsCard";

export default function HomeMatchAdsPage() {
    const defaultLimit = 20;

    const [state, setState] = React.useState({
        itemsLoaded: false,
        items: [] as HomeMatchAdDto[],
        onlyActive: true,
        offset: 0,
        limit: defaultLimit,
        totalPages: 0,
        currentPage: 1
    });

    const navigate = useNavigate()

    const loadPage = async (onlyActive: boolean, offset: number, limit: number) => {
        const response = await getHomeMatchAds(onlyActive, offset, limit);
        const items = response?.items ?? [];
        const totalItems = response?.totalItems ?? 0;
        const totalPages = Math.ceil(totalItems / limit);
        const currentPage = totalItems > 0 ? Math.ceil((offset + limit) / limit) : 1;

        setState(prevState => ({
            ...prevState,
            items: items,
            totalPages: totalPages,
            currentPage: currentPage,
            onlyActive: onlyActive,
            itemsLoaded: true
        }));
    }

    const onPageChanged = async (p: number) => {
        await loadPage(state.onlyActive, (p - 1) * state.limit, state.limit);
    }

    const onActiveChanged = async (active: boolean) => {
        setState(prevState => ({ ...prevState, offset: 0, limit: defaultLimit, onlyActive: active }));
        await loadPage(active, 0, defaultLimit);
    }

    const onDeleteAd = async (adId: string) => {
        if (window.confirm('Are you sure you want to delete this ad?')) {
            const success = await deleteHomeMatchAd(adId);
            if (success) {
                await loadPage(state.onlyActive, state.offset, state.limit);
            } else {
                alert('Failed to delete ad');
            }
        }
    }

    React.useEffect(() => {
        const fetchData = async () => {
            await loadPage(state.onlyActive, state.offset, state.limit);
        }

        fetchData();
    }, [])

    return (
        <Stack gap="50px 50px" sx={{mx: 5, my: 5}} justifyContent='center' alignItems='center'>
            <Grid container spacing={2} columns={{xs: 1, sm: 2, md: 4, lg: 5}} justifyContent="flex-end">
                <Grid item xs={1} key="addButton" alignContent="center">
                    <Button variant="contained" fullWidth={true} style={{height: '54px'}}
                            onClick={() => navigate('/home-match-ads/add')}>Add new Ad</Button>
                </Grid>
            </Grid>
            <Typography variant="h3">Home Match Ads</Typography>
            {!state.itemsLoaded ? <CircularProgress size={64} style={{marginBottom: '32px'}}/> : <div/>}
            <Grid container spacing={2} columns={{xs: 1, sm: 2, md: 3, lg: 4}} alignItems='center'>
                <Grid item xs={1}>
                    <Pagination count={state.totalPages} size="medium" onChange={(e, p) => onPageChanged(p)} page={state.currentPage} />
                </Grid>
                <Grid item xs={1} key="activeFilter" alignContent="center">
                    <FormControlLabel control={<Switch checked={state.onlyActive} onChange={e => onActiveChanged(e.target.checked)} />} label="Show only active" />
                </Grid>
            </Grid>
            <Grid container spacing={5} columns={{xs: 1, sm: 1, md: 2, lg: 3, xl: 4}}>
                <Box width='100%'/>
                {
                    state.items.map(x =>
                        <Grid item xs={1} key={x.id}>
                            <HomeMatchAdsCard item={x} showEdit={true} onDelete={() => onDeleteAd(x.id!)} />
                        </Grid>)
                }
            </Grid>
        </Stack>
    );
}